import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  FormsModule,
  ReactiveFormsModule
];

@Component({
  selector: 'app-topwidget',
  standalone: true,
  imports: [MODULES],
  templateUrl: './topwidget.component.html',
  styleUrl: './topwidget.component.css',
})
export class TopWidgetComponent {

  constructor(
  ) {
  }

  public onClick() {
    window.location.href = "tg://resolve?domain=dexbee_plus_support_bot";
  }
}
